
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'profile-info': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.88 2.00001H12.6667C13.4 2.00001 14 2.60001 14 3.33334V12.6667C14 13.4 13.4 14 12.6667 14H3.33333C2.6 14 2 13.4 2 12.6667V3.33334C2 2.60001 2.6 2.00001 3.33333 2.00001H6.12C6.4 1.22667 7.13333 0.666672 8 0.666672C8.86667 0.666672 9.6 1.22667 9.88 2.00001ZM8.66667 2.66667C8.66667 2.30001 8.36667 2.00001 8 2.00001C7.63333 2.00001 7.33333 2.30001 7.33333 2.66667C7.33333 3.03334 7.63333 3.33334 8 3.33334C8.36667 3.33334 8.66667 3.03334 8.66667 2.66667ZM8 4.66667C9.10667 4.66667 10 5.56001 10 6.66667C10 7.77334 9.10667 8.66667 8 8.66667C6.89333 8.66667 6 7.77334 6 6.66667C6 5.56001 6.89333 4.66667 8 4.66667ZM4 11.7333V12.6667H12V11.7333C12 10.4 9.33333 9.66667 8 9.66667C6.66667 9.66667 4 10.4 4 11.7333Z" fill="#93A0AE"/>'
  }
})
